import logo from "@/assets/logo.jpg";
import { COMPANY } from "@/data/site";
import VisitorCounter from "@/components/site/VisitorCounter";

export default function Footer() {
  return (
    <footer className="relative bg-[#0A111F] border-t border-white/10 overflow-hidden">
      <div className="pointer-events-none absolute -bottom-16 left-1/2 -translate-x-1/2 select-none font-heading text-[26vw] font-semibold leading-none text-white/[0.03]">
        S&amp;P
      </div>

      <div className="relative mx-auto max-w-7xl px-6 md:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <img src={logo} alt="S&P Reinigungsservice" className="h-12 w-12 rounded-full object-cover ring-1 ring-white/20" />
              <span className="font-heading text-lg font-semibold text-white leading-tight">S&amp;P<br/>Reinigungsservice</span>
            </div>
            <p className="text-sm font-light text-white/50 max-w-xs">{COMPANY.slogan}</p>
          </div>

          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-cyan-glass mb-5">Kontakt</div>
            <a href={`tel:${COMPANY.phoneRaw}`} className="block text-white/70 hover:text-white transition-colors mb-2">{COMPANY.phone}</a>
            <a href={`mailto:${COMPANY.email}`} className="block text-white/70 hover:text-white transition-colors break-all">{COMPANY.email}</a>
          </div>

          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-cyan-glass mb-5">Adresse</div>
            <p className="text-white/70">{COMPANY.street}</p>
            <p className="text-white/70">{COMPANY.zip}</p>
          </div>

          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-cyan-glass mb-5">Öffnungszeiten</div>
            {COMPANY.hours.map((h) => (
              <p key={h.d} className="text-white/70 text-sm mb-1">{h.d}: {h.h}</p>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-mono text-xs text-white/40">© {new Date().getFullYear()} {COMPANY.name}. Alle Rechte vorbehalten.</p>
          <div className="flex items-center gap-6">
            <a href="/impressum" data-testid="footer-impressum-link" className="font-mono text-xs text-white/40 hover:text-cyan-glass transition-colors">Impressum</a>
            <a href="/datenschutz" data-testid="footer-datenschutz-link" className="font-mono text-xs text-white/40 hover:text-cyan-glass transition-colors">Datenschutz</a>
          </div>
        </div>
      </div>
      <VisitorCounter />
    </footer>
  );
}
